



























































































import {
    BAlert,
    BCard,
    BCardGroup,
    BCardText,
    BForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormInvalidFeedback,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormText,
} from "bootstrap-vue";
import useMessageTemplates from "@/composables/useMessageTemplates";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";
import WabaChannels from "@/views/modules/settings/whatsapp-templates/components/wabaChannels.vue";
import { ValidationProvider } from "vee-validate";
import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { TemplateInterface } from "@/interfaces/template.interface";

export default defineComponent({
    components: {
        BAlert,
        BFormCheckboxGroup,
        BFormCheckbox,
        ValidationProvider,
        BFormGroup,
        BCard,
        BCardGroup,
        BCardText,
        BForm,
        BFormInput,
        BFormText,
        BFormSelect,
        DescriptionInputCounter,
        BFormInvalidFeedback,
        WabaChannels,
    },
    directives: {},
    emits: ["is-dirty"],
    props: {
        lockMetadata: {
            required: false,
            type: Boolean,
        },
        value: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },

    setup(props, { emit }) {
        const { messageTemplateLanguages, messageTemplateCategories } = useMessageTemplates();

        const template = computed<TemplateInterface>({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        const title = ref(template.value.title || "");

        const cleanUpTitle = () => {
            title.value = title.value
                .replace(/\s/g, "_")
                .replace(/[^a-z0-9_]/gi, "")
                .toLowerCase();

            template.value.title = title.value;
        };

        return {
            messageTemplateLanguages,
            messageTemplateCategories,
            template,
            title,
            cleanUpTitle,
        };
    },
});
